document.addEventListener('DOMContentLoaded', function () {
  var body = document.getElementById('tpu_cap_body');
  var container = document.querySelector('.tpu_cap_preview');
  if (!body || !container) return;

  var mockupItems = document.querySelectorAll('.tpu_mockup_item');

  document.querySelectorAll('.tpu_swatch[data-color]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var color = btn.getAttribute('data-color');
      mockupItems.forEach(function (item) { item.style.backgroundColor = color; });
      document.querySelectorAll('.tpu_swatch').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });
  var custom = document.getElementById('tpu_custom_color');
  if (custom) {
    custom.addEventListener('input', function () {
      var color = custom.value;
      mockupItems.forEach(function (item) { item.style.backgroundColor = color; });
      document.querySelectorAll('.tpu_swatch').forEach(function (b) { b.classList.remove('is-active'); });
    });
  }

  function activate(src) {
    document.querySelectorAll('.tpu_watermark_img').forEach(function (overlay) {
      if (overlay.src !== src) overlay.src = src;
    });
    container.classList.add('active');
    document.querySelectorAll('.custom-slider-main').forEach(function (el) { el.classList.add('dn'); });
  }

  var current = null;
  function watchThumb(thumb) {
    if (thumb === current) return;
    current = thumb;
    if (thumb.src && thumb.src.trim() !== '') activate(thumb.src);
    new MutationObserver(function () {
      if (thumb.src && thumb.src.trim() !== '') activate(thumb.src);
    }).observe(thumb, { attributes: true, attributeFilter: ['src'] });
  }

  new MutationObserver(function () {
    var thumb = document.querySelector('img.uploadkit-thumbnail');
    if (thumb) watchThumb(thumb);
  }).observe(document.body, { childList: true, subtree: true });
});
